<template>
  <b-row class="my-3">
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group
        label="Reset MPIN"
        class="mb-2"
        label-class="head-label"
      >
      </b-form-group>
    </b-col>
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group label="New MPIN">
        <b-input-group>
          <b-form-input
            maxlength="4"
            v-model="form.mpin"
            placeholder="Enter New MPIN"
            :type="showPassword['mpin'] ? 'text' : 'password'"
            @keypress.native="filterNumeric"
            @keyup.native="trimNumber('mpin')"
            :state="isInvalid('mpin')"
            class="border-right-0"
            pattern="[0-9]*"
            inputmode="numeric">
          </b-form-input>
          <b-input-group-prepend>
            <b-button
              :class="['rounded-right show-password-toggle bg-white shadow-none border-left-0 pl-3 pr-4', {
                'border-danger': isInvalid('mpin') !== null,
                'shown': showPassword['mpin']
              }]"
              @click="showPassword['mpin'] = !showPassword['mpin']">
            </b-button>
          </b-input-group-prepend>
        </b-input-group>
        <b-form-invalid-feedback :state="isInvalid('mpin')">
          {{ errorMessage("mpin") }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group label="Confirm New MPIN">
        <b-input-group>
          <b-form-input
            maxlength="4"
            v-model="form.confirm"
            placeholder="Confirm New MPIN"
            :type="showPassword['confirm'] ? 'text' : 'password'"
            @keypress.native="filterNumeric"
            @keyup.native="trimNumber('confirm')"
            :state="isInvalid('confirm')"
            class="border-right-0"
            pattern="[0-9]*"
            inputmode="numeric">
          </b-form-input>
          <b-input-group-prepend>
            <b-button
              :class="['rounded-right show-password-toggle bg-white shadow-none border-left-0 pl-3 pr-4', {
                'border-danger': isInvalid('confirm') !== null,
                'shown': showPassword['confirm']
              }]"
              @click="showPassword['confirm'] = !showPassword['confirm']">
            </b-button>
          </b-input-group-prepend>
        </b-input-group>
        <b-form-invalid-feedback :state="isInvalid('confirm')">
          {{ errorMessage("confirm") }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <b-form-input type="text" hidden="hidden" :state="isInvalid('pin')"></b-form-input>
        <b-form-invalid-feedback :state="isInvalid('pin')">
          {{ errorMessage("pin") }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group class="text-center">
        <b-button
          pill
          variant="primary"
          class="text-uppercase text-white w-100"
          @click="validateFields">
          Proceed
        </b-button>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import notification from "@/services/notification";

function initForm() {
  return {
    mpin: null,
    confirm: null
  }
}

export default {
  name: "ResetMpin",
  data() {
    return {
      form: initForm(),
      showPassword: {
        mpin: false,
        confirm: false
      }
    }
  },
  computed: {
    ...mapGetters("auth", ["isLoading", "errors"])
  },
  beforeDestroy() {
    this.setErrors(null);
  },
  methods: {
    ...mapMutations("auth", ["setErrors"]),
    ...mapActions("auth", ["resetMpin"]),
    isNotNumeric(input) {
      return /[^0-9]/g.test(input);
    },
    filterNumeric(e) {
      if (this.isNotNumeric(String.fromCharCode(e.keyCode))) e.preventDefault();
    },
    isInvalid(field) {
      if (this.errors === null) {
        return null;
      } else {
        return !Object.keys(this.errors).includes(field)
          ? null
          : !Object.keys(this.errors).includes(field);
      }
    },
    errorMessage(field) {
      if (this.errors === null) {
        return "";
      } else if (Object.keys(this.errors).includes(field)) {
        return Array.isArray(this.errors[field])
          ? this.errors[field].join(" ")
          : this.errors[field];
      }
    },
    validateFields() {
      const errors = {};
      const requiredFields = ["mpin", "confirm"];

      requiredFields.map(field => {
        if (!this.form[field]) errors[field] = `${field === "mpin" ? "New MPIN" : "Confirm New MPIN"} is required`;
        else if (this.form[field] && this.isNotNumeric(this.form[field])) errors[field] = "Only numeric characters are allowed";
      });

      if (this.form.mpin && this.form.mpin !== this.form.confirm) errors["confirm"] = "The Confirm PIN must match your New MPIN";

      this.setErrors(errors);

      if (Object.keys(errors).length === 0) this.submitForm()
      else notification.warning("Oops, something went wrong.");
    },
    async submitForm() {
      await this.resetMpin(this.form.mpin)
        .then(() => {
          if (this.errors === null || Object.keys(this.errors).length === 0) {
            this.$router.push({ name: "ResetSuccess" });
          }
        });
    },
    trimNumber: function(ref) {
      if (this.form[ref])
        this.form[ref] = this.form[ref].replace(/\D/g, "");
    },
  }
}
</script>

<style lang="scss" scoped>
.show-password-toggle {
  border-color: #ced4da;
  background: white url("../../assets/images/eye-fill.svg") no-repeat center;
  &.shown {
    background: white url("../../assets/images/eye-off-fill.svg") no-repeat center;
  }
  &:active:focus {
    border-color: #ced4da;
  }
}
</style>
